import { PortfolioPageSectionBadge } from "@/components/portfolio/portfolio-page/PortfolioPageSectionBadge";
import { PortfolioPageInsightItem } from "@/components/portfolio/portfolio-page/PortfolioPageInsightItem";
import {
  ClipboardDocumentCheckIcon,
  InboxStackIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import { useWatchDogContext } from "@/context/WatchDogContext";
import { Grid3x3Icon } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Panel } from "@/components/ui/Panel";

export type WatchDogOverviewContextPanelProps = {
  watchDogCount: number;
  activeViewLabel: string;
  activeViewDescription: string;
};

export function WatchDogOverviewContextPanel({
  watchDogCount,
  activeViewLabel,
  activeViewDescription,
}: WatchDogOverviewContextPanelProps) {
  const { language } = useLanguage();
  const copy = {
    cs: {
      currentContext: "Aktuální kontext",
      watchdogCount: "Počet hlídacích psů",
      of: "z",
    },
    en: {
      currentContext: "Current context",
      watchdogCount: "Number of watchdogs",
      of: "of",
    },
  }[language];
  const { membershipInfo } = useWatchDogContext();
  return (
    <Panel>
      <div className="space-y-1">
        <PortfolioPageSectionBadge type={"dark"}>
          {copy.currentContext}
        </PortfolioPageSectionBadge>
      </div>

      <div className="mt-4 space-y-2">
        <PortfolioPageInsightItem
          icon={ClipboardDocumentCheckIcon}
          title={copy.watchdogCount}
          text={
            <span className={"text-lg"}>
              {watchDogCount}
              <span className="text-xs ">
                {" "}
                {copy.of} {membershipInfo?.maxWatchDogs}
              </span>
            </span>
          }
        />
        <PortfolioPageInsightItem
          icon={InboxStackIcon}
          title={activeViewLabel}
          text={activeViewDescription}
        />
      </div>
    </Panel>
  );
}
